module.exports = __webpack_public_path__ + "img/LIN.OQ.8cb6d4a3.png";